<template>
    <div v-if="preference" class="choice-answers justify-content-left">
      <div
        v-for="(answer, index) in preference.answers"
        :key="answer.id"
        class="d-flex font-szie-14 choice-text flex-grow-1"
      >
        <div 
        class="w-100"
        v-if="isAnswerVisible(value, index) && (answer.value != null)">
          <div style="word-wrap: break-word;" 
          :class="aligmentCss"
          class="d-flex  text-size-12 ">
            {{ renderAnswerLable(index) }}
          </div>
          <div style="word-wrap: break-word;" 
          :class="aligmentCss"
          class="d-flex  text-size-16 pb-2 ">
            {{ renderChoiceAnswer(index, answer) }}
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { answerMixin } from '../mixins/AnswerMixins.js';

export default {
  name: 'RenderCustomAnswers',
  mixins: [answerMixin],

  props: {
    value: {
      type: Number,
      required: true,
    },

    preference: {
      type: Object,
      default: null,
    },

    isCentered: {
       type: Boolean,
       default: true
    }
  },

  computed: {
    aligmentCss() {
      if( this.isCentered ) {
        return "justify-content-center"
      }
      return "justify-content-end"      
    }
  }


};
</script>
<style scoped>

.choice-answers {
  width:100%;
}
</style>
